// Auth
export const AUTH_SIGNIN_ROUTE: string = 'auth/signin';
export const AUTH_NEW_PASSWORD_ROUTE: string = 'auth/new/password';
export const AUTH_MFA_ROUTE: string = 'auth/mfa';

// Home
export const HOME_ROUTE: string = 'home';

// Companies
export const COMPANIES_ROUTE: string = 'companies';
export const ARCHIVED_COMPANIES_ROUTE: string = 'companies/archived';
export const COMPANY_DETAILS_ROUTE: string = 'company';

// Sellers
export const SELLERS_ROUTE: string = 'sellers';
export const SELLER_DETAILS_ROUTE: string = 'seller';

// Stores
export const STORES_ROUTE: string = 'stores';
export const STORE_DETAILS_ROUTE: string = 'store';

// Orders
export const ORDERS_ROUTE: string = 'orders';
export const ORDER_DETAILS_ROUTE: string = 'order';

// Buyers
export const BUYERS_ROUTE: string = 'buyers';
export const BUYER_DETAILS_ROUTE: string = 'buyer';

// Steps
export const STEPS_ROUTE: string = 'steps';

// Report
export const REPORT_ROUTE: string = 'report';

// Unpaid
export const UNPAID_ROUTE: string = 'unpaid';

// Scripts
export const SCRIPTS_ROUTE: string = 'scripts';

// Pending Invitations
export const PENDING_INVITATIONS_ROUTE: string = 'pending-invitations';

// Vop
export const VOP_REQUIEST_ROUTE: string = 'vop-request';

// Settings
export const SETTINGS_ROUTE: string = 'settings';
export const PRODUCT_CATEGORY_ROUTE: string = 'product-category';
export const PRODUCT_SUBCATEGORY_ROUTE: string = 'product-subcategory';
export const CLUSTER_ROUTE: string = 'cluster';
